var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "clip-path": "url(#linkedin_svg__clip0_1508_4769)",
      "fill": "#fff"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.816 13.818v-.001h.003V8.749c0-2.48-.534-4.39-3.432-4.39-1.394 0-2.329.765-2.71 1.49h-.041V4.591H4.888v9.226h2.861V9.249c0-1.203.228-2.366 1.718-2.366 1.468 0 1.49 1.372 1.49 2.443v4.492h2.859zM.228 4.594h2.865v9.226H.228V4.594zM1.66 0A1.66 1.66 0 000 1.66c0 .916.743 1.674 1.66 1.674.916 0 1.659-.758 1.659-1.675A1.66 1.66 0 001.659 0z"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "linkedin_svg__clip0_1508_4769"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M0 0h14v14H0z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }